var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "my-4" },
    [
      _c("section-title", { attrs: { "has-line": true, title: "Documentos" } }),
      _vm._l(_vm.items, function(item, index) {
        return _c(
          "div",
          {
            key: `document-row-${index}`,
            staticClass: "row bg-secondary-3 rounded p-3 mb-3 ml-1 mr-0"
          },
          [
            _c("div", { staticClass: "col-md-6" }, [
              _c(
                "div",
                { staticClass: "color-gray-6 font-14 font-weight-normal" },
                [_vm._v(" Tipo de Documento: ")]
              ),
              _c(
                "div",
                { staticClass: "color-black font-16 font-weight-normal" },
                [_vm._v(" " + _vm._s(item.documentTypeName) + " ")]
              )
            ]),
            _c(
              "div",
              { staticClass: "col-md-6 d-flex" },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "color-gray-6 font-14 font-weight-normal mr-3 mt-2"
                  },
                  [_vm._v(" Documento: ")]
                ),
                _c("validation-provider", {
                  attrs: {
                    name: item.documentTypeName,
                    rules: item.itemAttachmentId ? "" : item.rules
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-file-input", {
                              ref: "attachedDocument",
                              refInFor: true,
                              attrs: {
                                accept: ".pdf",
                                "attachment-id": item.itemAttachmentId,
                                "custom-error-msg":
                                  "Favor de anejar un documento.",
                                disabled: _vm.readonly,
                                "display-style": "normal",
                                error: errors[0],
                                "label-position": "left",
                                "max-size": 10,
                                name: item.filename,
                                "on-download": _vm.downloadFile,
                                required: ""
                              },
                              on: {
                                "after-remove": function($event) {
                                  item.itemAttachmentId = null
                                },
                                input: function($event) {
                                  return _vm.$emit("input")
                                }
                              },
                              model: {
                                value: item.file,
                                callback: function($$v) {
                                  _vm.$set(item, "file", $$v)
                                },
                                expression: "item.file"
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              ],
              1
            )
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }